"use client";

import { useEffect } from "react";
import { enqueueScripts } from "~/components/Wordpress/utils";

type Script = {
    id?: string | null;
    type?: string | null;
    src?: string | null;
    content?: string | null;
}

type Props = {
    scripts: Script[];
};

export const Wordpress = ({ scripts }: Props) => {
    useEffect(() => {
        document.body.classList.add("elementor-page-");

        const list = scripts.map((script) => {
            const el = document.createElement("script");

            if (script.src) {
                el.src = script.src;
            } else if (script.content) {
                el.textContent = script.content;
            }

            if (script.id) el.id = script.id;
            if (script.type) el.type = script.type;

            return el;
        });

        void enqueueScripts(list).then(() => {
            const { elementorFrontend, elementorProFrontend } = window;
            if (!elementorFrontend) return;

            dispatchEvent(new CustomEvent("DOMContentLoaded"));

            const { documentsManager, hooks } = elementorFrontend;

            if (hooks) {
                dispatchEvent(new CustomEvent("elementor/frontend/init"));
                elementorFrontend.onDocumentLoaded();

                if (documentsManager) {
                    hooks.doAction("elementor/frontend/documents-manager/init-classes", documentsManager);
                }
            }

            if (elementorProFrontend) {
                const { modules } = elementorProFrontend;

                if (modules?.popup) {
                    modules.popup.onFrontendComponentsInit();
                }
            }

            const initializeSwiper = (iteration = 0) => {
                const selector = ".elementor-widget-container .swiper:not(.swiper-initialized)";

                document.querySelectorAll(selector).forEach(node => {
                    const widget = node.closest(".elementor-widget");
                    if (!widget || !elementorFrontend.elementsHandler) return;
                    elementorFrontend.elementsHandler.runReadyTrigger(widget);
                });

                if ( document.querySelectorAll(selector).length && iteration < 5 ) {
                    setTimeout(initializeSwiper, 1000, iteration + 1);
                }
            }

            initializeSwiper();
        });

        return () => {
            dispatchEvent(new CustomEvent("wordpress/unmount"));
        }
    }, [scripts]);

    return null;
};

export default Wordpress;